export default "<app-about [titleSectionProp]=\"titleSectionProp\" [List]=\"Lists\"></app-about>\n"